import {Inquiry, inquiryDecoder} from './Inquiry'
import {
    InquiryStatusChangeWithUsers,
    inquiryStatusChangeWithUsersDecoder
} from './InquiryStatusChangeWithUsers'
import {InquiryProofCopy, inquiryProofCopyDecoder} from './InquiryProofCopy'
import {Decoder, field, nullable, object} from 'json-bouncer'

export interface ProofCopyWithDetails {
    readonly proofCopy: InquiryProofCopy
    readonly inquiry: Inquiry
    readonly inquiryStatusChangeWithUsers: InquiryStatusChangeWithUsers | null
}

export function proofCopyWithDetailsDecoder(): Decoder<ProofCopyWithDetails> {
    return object({
        proofCopy: field('proofCopy', inquiryProofCopyDecoder()),
        inquiry: field('inquiry', inquiryDecoder()),
        inquiryStatusChangeWithUsers:
            field(
                'inquiryStatusChangeWithUsers',
                nullable(inquiryStatusChangeWithUsersDecoder()),
            ),
    })
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Entities/ProofCopyWithDetails.ts